
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gallery/[gallery]",
      function () {
        return require("private-next-pages/gallery/[gallery].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gallery/[gallery]"])
      });
    }
  